import { render } from "./BottomNavItem.vue?vue&type=template&id=1f479cb9"
import script from "./BottomNavItem.vue?vue&type=script&lang=js"
export * from "./BottomNavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__